<template>
  <login-layout :title="$t('Invito ad accedere all\'area riservata.')">
    <pf-spinner v-if="inviteState.updating" />

    <template v-else-if="invite?.azienda">
      <pf-content>
        {{ $t("Sei stato invitato ad accedere all'area riservata di {0}", [invite.azienda]) }}
        {{ $t('Questo ti consentirà di:') }}
        <ul>
          <li v-if="invite.grants">{{ $t('Gestire e consultare i dati tecnici dei servizi.') }}</li>
          <li v-if="invite.email_subscriptions?.includes('technical')">
            {{ $t("Ricevere in copia le notifiche tecniche dell'azienda") }}
          </li>
          <li v-if="invite.email_subscriptions?.includes('billing')">
            {{ $t("Ricevere in copia le notifiche amministrative dell'azienda") }}
          </li>
          <li v-if="invite.email_subscriptions?.includes('marketing')">
            {{ $t("Ricevere in copia le notifiche commerciali dell'azienda") }}
          </li>
        </ul>
      </pf-content>

      <pf-button variant="primary" large block :disabled="sending" @click="submit" :loading="sending" class="pf-v6-u-mt-lg">
        {{ $t('Accetta Invito') }}
      </pf-button>
    </template>

    <p v-else>{{ $t("L'invito non è valido o è scaduto.") }}</p>

    <pf-button large block variant="secondary" @click="next"  class="pf-v6-u-mt-sm">{{ $t('Ignora') }}</pf-button>
  </login-layout>
</template>

<script lang="ts" setup>
import { http } from '../../http';
import { asyncComputed } from '@common/asyncComputed';
import { pop } from '@common/utils';
import { loginDestination } from '../../utils';
import LoginLayout from '../../components/login-layout.vue';
import { Resource } from '@/resources';
import { useLoginStore } from '@/store/login';
import type { Invite } from '@/typings/resources';
import { useRoute, useRouter } from 'vue-router';
import { useFunctionRunningState } from '@common/use';

defineOptions({
  name: 'AcceptInvitePage',
});

const route = useRoute();
const router = useRouter();

const { result: invite, state: inviteState } = asyncComputed(async() => {
  const antk = pop(route.params.antk);
  if (!antk) {
    return {};
  }
  return await new Resource('invites').get(antk);
}, null as Invite | null);

const { isRunning: sending, run: submit } = useFunctionRunningState(async() => {
  const data = new FormData();
  const antk = pop(route.params.antk);
  if (antk) {
    data.append('antk', antk);
  }

  const result = (await http.post('/api/auth/companylogin', data)).data.result;

  if (result == 'ok') {
    const login = useLoginStore();
    await login.refresh();
    next();
  }
});

function next() {
  router.push(loginDestination(route.query));
}
</script>
